// extracted by mini-css-extract-plugin
export default {"buttonContainer":"CreateStockedItems_buttonContainer__iZNnQ"};